
import { useEffect } from 'react';

const Pathogens = [
    {
        "id": 1,
        "path_name" : "Staphylococcus aureus",
        "positivity": "35.88%"
    },
    {
        "id": 2,
        "path_name" : "Bacillus cereus",
        "positivity": "17.13%"
    },
    {
        "id": 3,
        "path_name" : "Salmonella",
        "positivity": "13.43"
    },
    {
        "id": 4,
        "path_name" : "EPEC",
        "positivity": "12.27%"
    },
    {
        "id": 5,
        "path_name" : "EAEC",
        "positivity": "5.09%"
    },
    {
        "id": 6,
        "path_name" : "Vibrio cholerae",
        "positivity": "4.17%"
    },
    {
        "id": 7,
        "path_name" : "Vibrio parahaemolyticus",
        "positivity": "4.17%"
    },
    {
        "id": 8,
        "path_name" : "Listeria monocytogenes",
        "positivity": "3.01%"
    },
    {
        "id": 9,
        "path_name" : "Shigella",
        "positivity": "2.55%"
    },
    {
        "id": 10,
        "path_name" : "Campylobacter",
        "positivity": "1.39%"
    },
    {
        "id": 11,
        "path_name" : "ETEC",
        "positivity": "0.46"
    },
    {
        "id": 12,
        "path_name" : "Yersinia enterocolitica",
        "positivity": "0.46%"
    }
]


export const getPathogenPositivity = () => {
    return Pathogens
}

const statePositivity = [
    {
        "id": 1,
        "state_name": "Arunachal Pradesh",
        "tested": 2074,
        "positive": 37,
        "percent": '1.8%'
    },
    {
        "id": 2,
        "state_name": "Assam",
        "tested": 4315,
        "positive": 68,
        "percent": '1.6%'
    },
    {
        "id": 3,
        "state_name": "Sikkim",
        "tested": 4776,
        "positive": 288,
        "percent": '6.0%'
    },
    {
        "id": 4,
        "state_name": "Tripura",
        "tested": 2816,
        "positive": 39,
        "percent": '1.4%'
    },

]

export const getStatePositivity = () => {
    return statePositivity
}

const HospitalPathogens = [
    {
        "id": 1,
        "path_name" : "EPEC",
        "positivity": "35.88%"
    },
    {
        "id": 2,
        "path_name" : "Shigella",
        "positivity": "17.13%"
    },
    {
        "id": 3,
        "path_name" : "Salmonella",
        "positivity": "13.43"
    },
    {
        "id": 4,
        "path_name" : "ETEC",
        "positivity": "12.27%"
    },
    {
        "id": 5,
        "path_name" : "EAEC",
        "positivity": "5.09%"
    },
    {
        "id": 6,
        "path_name" : "Adeno Virus",
        "positivity": "4.17%"
    },
    {
        "id": 7,
        "path_name" : "Ascaris",
        "positivity": "4.17%"
    }
]

export const getHospitalPathogens = () => {
    return HospitalPathogens
}


export const disableBackButton =() => {
    window.history.pushState(null, "", window.location.href)
    window.onpopstate = function() {
        window.history.pushState(null, "", window.location.href)
    }
}